<template lang="pug">
    .searchable-filter-wrapper(v-on:mouseleave="handleMouseLeave")
        .label {{ getCustomLabel }}
        .search
            input(type="text" v-model="researchTerm" @input="handleSearch" spellcheck="false")
        .results-list-wrapper
            .row(v-for="item in results" :key="item.id" @click="handleClick(item)") {{ item.name }}
                span.selected(v-if="activeFilters[filter.key].find(x => x.id === item.id)") &#10003;
            .row.not-clickable(v-if="noResults && !results.length") {{ getCustomNoResultsMessage }}
            .row.not-clickable(v-else-if="!success" v-html="getErrorMessage")
</template>

<script>
import { debounce } from 'lodash'

export default {
    // eslint-disable-next-line
    props: ["filter", "activeFilters", "searchResults"],
    data() {
        return {
            researchTerm: ''
        }
    },
    computed: {
        getCustomLabel() {
            return `Filter ${this.filter.label}`
        },
        getCustomNoResultsMessage() {
            return 'No results found'
        },
        getErrorMessage() {
            return 'Error while fetching data<br/>Please reload'
        },
        noResults() {
            return this.searchResults.noResults
        },
        results() {
            return this.searchResults.results
        },
        success() {
            return this.searchResults.success
        }
    },
    methods: {
        handleClick(item) {
            const { key } = this.filter
            this.$emit('multiselection', 'update', { ...item, key })
        },
        handleMouseLeave() {
            this.$emit('closeSelection')
        },
        handleSearch: debounce(function() {
            this.$emit('termToResearch', this.researchTerm)
        }, 300)
    },
    mounted() {
        if (this.searchResults.researchTerm) {
            this.researchTerm = this.searchResults.researchTerm
        }
    }
}
</script>
